import { MOBILE_BREAKPOINT } from '@/app'
import { Page, Text, View } from '@/components'
import { NavigationUtils, privacy } from '@/utils'
import { useI18N, useMemo } from '@codeleap/common'
import { graphql } from 'gatsby'

const availableprivacyTerms = ['en', 'fr', 'de']

export default () => {
  const { locale } = useI18N()
  const { language = null } = NavigationUtils.getSearchParams()

  const current = useMemo(() => {
    let currentLocale = language
    if (!availableprivacyTerms.includes(currentLocale)) currentLocale = locale.substring(0, 2)
    if (!availableprivacyTerms.includes(currentLocale)) currentLocale = 'en'
    return privacy[currentLocale]
  }, [locale, language])

  return (
    <Page pageTitle={current.title} variants={['contentPaddings']}>
      <View variants={['column', 'gap:2', 'marginVertical:8']} responsiveVariants={{ [MOBILE_BREAKPOINT]: ['marginVertical:2'] }}>
        <Text text={current.title} variants={['h0']} responsiveVariants={{ [MOBILE_BREAKPOINT]: ['h2'] }} />
        {current.content.split('\n').map((t, i) => {
          const isTitle = !Number.isNaN(+t[0])
          const isNested = isTitle && t[1] === '.'

          if (!t.length) return null
          return (
            <Text
              key={`${t.substring(0, 10)}-${i}`}
              variants={[isNested ? 'h4' : isTitle ? 'h2' : 'p1']}
              responsiveVariants={{ [MOBILE_BREAKPOINT]: [isNested ? 'h5' : isTitle ? 'h4' : 'p1'] }}
              text={t}
            />
          )
        })}
      </View>
    </Page>
  )
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
